/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Voice_Agents_Scope_Detail5Inputs */

const en_svc_ai_voice_agents_scope_detail5 = /** @type {(inputs: Svc_Ai_Voice_Agents_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which calls the agent handles, and where it must hand off to a human.`)
};

const ar_svc_ai_voice_agents_scope_detail5 = /** @type {(inputs: Svc_Ai_Voice_Agents_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أي المكالمات يتولاها الوكيل وأين يجب تسليمها إلى إنسان.`)
};

const bn_svc_ai_voice_agents_scope_detail5 = /** @type {(inputs: Svc_Ai_Voice_Agents_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এজেন্ট কোন কল সামলাবে আর কোথায় মানুষের কাছে দিতে হবে।`)
};

const de_svc_ai_voice_agents_scope_detail5 = /** @type {(inputs: Svc_Ai_Voice_Agents_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Anrufe der Agent übernimmt und wo er an einen Menschen übergeben muss.`)
};

const es_svc_ai_voice_agents_scope_detail5 = /** @type {(inputs: Svc_Ai_Voice_Agents_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué llamadas gestiona el agente y dónde debe derivar a un humano.`)
};

const fr_svc_ai_voice_agents_scope_detail5 = /** @type {(inputs: Svc_Ai_Voice_Agents_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quels appels l'agent gère et où il doit passer la main à un humain.`)
};

const pt_svc_ai_voice_agents_scope_detail5 = /** @type {(inputs: Svc_Ai_Voice_Agents_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que chamadas o agente trata e onde deve passar a um humano.`)
};

const zh_svc_ai_voice_agents_scope_detail5 = /** @type {(inputs: Svc_Ai_Voice_Agents_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`明确助手处理哪些通话，以及必须在何处转交人工。`)
};

const tr_svc_ai_voice_agents_scope_detail5 = /** @type {(inputs: Svc_Ai_Voice_Agents_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asistanın hangi çağrıları üstleneceği ve nerede insana devretmesi gerektiği.`)
};

const ru_svc_ai_voice_agents_scope_detail5 = /** @type {(inputs: Svc_Ai_Voice_Agents_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Какие звонки ведёт агент и где он обязан передать человеку.`)
};

const pl_svc_ai_voice_agents_scope_detail5 = /** @type {(inputs: Svc_Ai_Voice_Agents_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Które połączenia prowadzi agent i gdzie musi przekazać człowiekowi.`)
};

/**
* | output |
* | --- |
* | "Which calls the agent handles, and where it must hand off to a human." |
*
* @param {Svc_Ai_Voice_Agents_Scope_Detail5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_voice_agents_scope_detail5 = /** @type {((inputs?: Svc_Ai_Voice_Agents_Scope_Detail5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Voice_Agents_Scope_Detail5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_voice_agents_scope_detail5(inputs)
	if (locale === "bn") return bn_svc_ai_voice_agents_scope_detail5(inputs)
	if (locale === "de") return de_svc_ai_voice_agents_scope_detail5(inputs)
	if (locale === "es") return es_svc_ai_voice_agents_scope_detail5(inputs)
	if (locale === "fr") return fr_svc_ai_voice_agents_scope_detail5(inputs)
	if (locale === "pt") return pt_svc_ai_voice_agents_scope_detail5(inputs)
	if (locale === "zh") return zh_svc_ai_voice_agents_scope_detail5(inputs)
	if (locale === "tr") return tr_svc_ai_voice_agents_scope_detail5(inputs)
	if (locale === "ru") return ru_svc_ai_voice_agents_scope_detail5(inputs)
	if (locale === "pl") return pl_svc_ai_voice_agents_scope_detail5(inputs)
	return en_svc_ai_voice_agents_scope_detail5(inputs)
});
export { svc_ai_voice_agents_scope_detail5 as "svc_ai-voice-agents_SCOPE_detail" }